export const uxDesignerDocumentation = {
  all: [
    'Design System Documentation',
    'User Research Repository', 
    'Accessibility Standards',
    'Design Process Guide',
    'Handoff Documentation'
  ],
  junior: [
    'Getting Started Guide',
    'Design Critique Guidelines',
    'Basic Research Methods',
    'Tool Setup Instructions'
  ],
  mid: [
    'Advanced Research Methods',
    'Design Ops Processes',
    'Cross-functional Collaboration',
    'Quality Standards'
  ],
  senior: [
    'Design Leadership Handbook',
    'Strategic Planning Guide', 
    'Team Management Docs',
    'Design Governance'
  ]
};
